import React from 'react'
import Insights from 'pages/Owner/Insights'

interface ClientInsightsProps {
  clientId: string
}

const ClientInsights: React.FC<ClientInsightsProps> = ({ clientId }) => {
  return <Insights clientId={clientId} />
}

export default ClientInsights
